import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface UploadMusicParams {
  actId: string;
  performanceId: string;
  file: File;
}

export interface UploadMusicResponse {
  url: string;
  filename: string;
}

export const uploadMusicAPI = async ({
  actId,
  performanceId,
  file,
}: UploadMusicParams) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await baseAPI.post<UploadMusicResponse>(
    `/acts/${actId}/performances/${performanceId}/music`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
};

export const useUploadMusicMutation = () => {
  return useMutation({
    mutationFn: async (params: UploadMusicParams) => {
      return await uploadMusicAPI(params);
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACTS, variables.actId, KEYS.PERFORMANCES],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PERFORMANCES, variables.performanceId],
      });
    },
    onError: (error: AxiosError<{ message: string }>) => {
      const errorMessage =
        error.response?.data.message ?? 'Failed to upload music file';
      toast.error(errorMessage);
    },
  });
};
